import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useEffect, useState } from 'react';
import ExternalPricelistList from '../externalpricelist/ExternalPricelistList';

type Props = {
    handleExternalPricelistSelected: (ref: number[]) => void;
    multiSelect: boolean;
    handleClose: () => void;
    selectedExtPricelistIds: number[];
};

export const ExternalPricelistDialog = ({
    handleClose,
    selectedExtPricelistIds,
    multiSelect,
    handleExternalPricelistSelected
}: Props) => {
    const [selectedExternalPricelistIds, setSelectedExternalPricelistIds] = useState<number[]>([]);
    const [hasSelectedExternalPricelist, setHasSelectedExternalPricelist] = useState(false);

    useEffect(() => {
        setSelectedExternalPricelistIds(selectedExtPricelistIds);
        setHasSelectedExternalPricelist(selectedExtPricelistIds.length > 0);
    }, [selectedExtPricelistIds]);

    const handleSetSelectedPricelist = (externalPricelistIds: number[]) => {
        setSelectedExternalPricelistIds(externalPricelistIds);
        setHasSelectedExternalPricelist(externalPricelistIds.length > 0);
    };

    const handleSubmit = () => {
        if (handleExternalPricelistSelected != null) {
            handleExternalPricelistSelected(selectedExternalPricelistIds!);

            handleClose();
        }
    };

    return (
        <Dialog
            open={true}
            onClose={handleClose}
            scroll="paper"
            sx={{ minWidth: '250px', minHeight: '400px' }} //Check if nested paper component somehow needs this
        >
            <DialogTitle>Choose pricelist</DialogTitle>
            <DialogContent dividers={true}>
                <ExternalPricelistList
                    selectedExternalPricelistIds={selectedExternalPricelistIds ?? []}
                    onSelectPricelist={handleSetSelectedPricelist}
                    multiselect={multiSelect}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    Cancel
                </Button>
                <Button color="primary" onClick={handleSubmit} disabled={!hasSelectedExternalPricelist}>
                    Select
                </Button>
            </DialogActions>
        </Dialog>
    );
};
